<page-title [title]="pageTitle"></page-title>

<vehicle-list-filter (searchFormSubmit)="handleFilterSearchForm($event)" (searchFormReset)="handleSearchFormReset($event)"
  [checkParams]="true" [serverError]="serverError"></vehicle-list-filter>

<vehicle-list [routeName]="'/vehicle-list-new'" [resetAndSearch]="resetAndSearch" (listLoaded)="vehicleListLoaded($event)"
  (sendError)="handleFormErrors($event)"></vehicle-list>
